import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "redux/store";
import { api } from "api/axiosInterceptor";
import {
  decrementRequests,
  incrementRequests,
  setIsLoading,
  setShowToast,
} from "./application";
import {  ITimelineState, TimeLineInfo } from "types/timeline";
import { convertToCamelCase } from "utils/utils";

const initialState: ITimelineState = {
  timeLineInfo: {
    data: {},
    filters: [],
    users: [],
  },
  auditInfo: {
    data: [],
    pagination: {
      total_pages : 0,
      total: 0,
    },
    users: [],
    events: []
  }
};

const slice = createSlice({
  name: "timeline",
  initialState,
  reducers: {
    timelineEvaluation(state, action: PayloadAction<TimeLineInfo>) {
      state.timeLineInfo = action.payload;
    },
    getAuditDetail(state, action: PayloadAction<ITimelineState["auditInfo"]>) {
      state.auditInfo = action.payload;
    },
  },
});

export const { timelineEvaluation, getAuditDetail} = slice.actions;

export default slice.reducer;

export const selectProjectDetails = (state: RootState) =>
  state.summaryData.projectDetails;

export function getTimelineDetail() {
  return async (dispatch: AppDispatch) => {
    dispatch(setIsLoading(true));
    try {
      const path = `/rfp/user/evalution/timeline/`;
      const response = await api.get(path);
      const formattedData = convertToCamelCase(response.data);
      dispatch(timelineEvaluation(formattedData));
      return response.status;
    } catch (error) {
      dispatch(
        setShowToast({
          show: true,
          type: "error",
          toastMessage: "Something went wrong!",
        })
      );
    } finally {
      dispatch(setIsLoading(false));
    }
  };
}

export function fetchAuditLogDetail(page: number, isCompanyAdmin?: boolean) {
  return async (dispatch: AppDispatch) => {
    dispatch(incrementRequests());
    try {
      const path = `/audit-logs/`;
      const response = await api.post(path, {
        event: "",
        user: "",
        page_length: 10,
        page_number: page,
        is_company_admin: isCompanyAdmin || false,
      });
      dispatch(getAuditDetail(response.data));
      return response.status;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.detail;
      dispatch(
        setShowToast({
          show: true,
          type: "error",
          toastMessage: errorMessage || "Something went wrong!",
        })
      );
    } finally {
      dispatch(decrementRequests());
    }
  };
}
